function Store () {
	var self = this;

	// Whether the user's browser has cookies enabled
	self.cookiesEnabled = navigator.cookieEnabled;

	/**
	* Returns a boolean indicating the browser has the capacity to store
	* either in cookies or local storage
	*
	* @method canStore
	* @returns {Boolean}
	*/
	self.canStore = function () {
		return ( self.cookiesEnabled || self.storageEnabled() );
	};


	/**
	* Removes an item from local storage or cookie
	*
	* @method del
	* @param {String} sKey The token to delete
	* @returns none
	*/
	self.del = function ( sKey ) {
		// Retrieves a list of cookies from the browser
		var aCookies = document.cookie.split(';'),
		// Instance of an individual cookie
		    c = null,
		// Standard increment
		    i = 0,
		// Local storage value
		    lVal = null;
		// String to compare
		    sNameEQ = sKey + '=',
		// Temporary holder of the value
		    val = null;

		// First look in the local storage for the item
		if ( self.storageEnabled() == true ) {
			val = localStorage.getItem( sKey );

			if ( val ) {
				localStorage.removeItem( sKey );
			}
		}

		// Now attempt to remove any cookies with the key
		// Loop over each cookie found
		for ( i = 0; i < aCookies.length; i++ ) {
			// remove any extra white space around the cookie
			c = $.trim( aCookies[i] );

			// If the cookie name requested is the current cookie
			// strip away the cookie name, and return the value
			if ( c.indexOf( sNameEQ ) == 0) {
				lVal = c.substring( sNameEQ.length, c.length );

				if ( lVal ) {
					document.cookie = sKey + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
				}
			}
		}
	};


	/**
	* Retrieves an item from storage
	*
	* @method get
	* @param {String} sKey The token to retrieve
	* @returns {String}
	*/
	self.get = function ( sKey ) {
		// Retrieves a list of cookies from the browser
		var aCookies = document.cookie.split(';'),
		// Instance of an individual cookie
		    c = null,
		// Standard increment
		    i = 0,
		// Local storage value
		    lVal = null;
		// String to compare
		    sNameEQ = sKey + '=';

		// Try to retrieve the value from local storage first
		if ( self.storageEnabled() == true ) {
			lVal = localStorage.getItem( sKey );

			if ( lVal && lVal != '' ) {
				return lVal;
			}
		}

		// Loop over each cookie found
		for ( i = 0; i < aCookies.length; i++ ) {
			// remove any extra white space around the cookie
			c = $.trim( aCookies[i] );

			// If the cookie name requested is the current cookie
			// strip away the cookie name, and return the value
			if ( c.indexOf( sNameEQ ) == 0) {
				lVal = c.substring( sNameEQ.length, c.length );

				if ( lVal && lVal != '' ) {
					return c.substring( sNameEQ.length, c.length );
				}
			}
		}


		// No matching cookie found; return null
		return null;
	};


	/**
	* Sets an item in local storage or cookie
	*
	* @method set
	* @param {String} sKey Token of the item to set
	* @param {String} sVal Value of the item to set
	* @param {Boolean} bUseCookie Whether or not to set via cookie (even if LocalStorage is available)
	* @param {Boolean} bPersist Whether the cookie should persist, or default to a session cookie
	* @returns
	*/
	self.set = function ( sKey, sVal, bUseCookie, bPersist ) {
		var now = new Date(),
		    sCookie = '';

		now.setFullYear( now.getFullYear() + 1 );

		if ( bUseCookie == true || self.storageEnabled() == false ) {
			sCookie = sKey + '=' + sVal +'; path=/;';

			if ( bPersist ) {
				sCookie +=  'expires=' + now.toUTCString() +';';
			}

			document.cookie = sCookie;
		}
		else {
			localStorage.setItem( sKey, sVal );
		}
	};


	/**
	* Indicates whether the browser supports local storage
	*
	* @method storageEnabled
	* @returns {Boolean}
	*/
	self.storageEnabled = function () {
		return (typeof(Storage) !== 'undefined');
	};


	// expose API
	return self;
}